import React, { FC, PropsWithChildren } from 'react';
import { Status } from '../status';
import { StatusProps } from '../status/models/types';
import { color } from './models/constants';

export const ProjectStatus: FC<StatusProps> = (
  props: PropsWithChildren<StatusProps>,
) => <Status {...props} color={color} />;
